<script setup lang="ts">
import type { DataTableCellProps } from './templateTypes';

/***
 * template to show simple cell string
 */
const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <div>
    {{ cell.value }}
  </div>
</template>
